let axios = require('axios').default;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.interceptors.response.use((response) => { // intercept the global error
    return response
  }, function (error) {
    if (error.response.status === 401) { 
         window.location.href = '/Auth/Login?returnUrl='+encodeURIComponent(window.location.pathname);
    }
    // Do something with response error
    return Promise.reject(error)
  });

(function() { 
    document.addEventListener('click', function(e) { 
        if(document.activeElement && 
           document.activeElement.classList && 
           document.activeElement.classList.contains('button'))
        { document.activeElement.blur(); }
    });
}());

function sticky(element) {
    var offset = element.offsetTop;
    var base = document.querySelector('.page__main');
    base.onscroll = function() {
        if (base.scrollTop >= offset) {
            element.style.width = element.offsetWidth + 'px';
            element.style.position = 'fixed';
            element.style.top = 0;
        } else {
            element.style.width = 'auto';
            element.style.position = 'static';
            element.style.top = 0;
        }
    }
}

var token = undefined;
function getToken() {
    if (token !== undefined)
        return token;
    
    var inputs = document.getElementsByName('__RequestVerificationToken');
    token = inputs.length > 0 ? inputs[0].value : false;
    return token;
}

axios.interceptors.request.use((config) => {
    if (config.method == "post") {
        var afToken = getToken();
        if (afToken)
            config.headers['X-XSRF-TOKEN'] = afToken;
    }
    return config; 
});

function isScrolledIntoView(el) {
    var rect = el.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;

    // Only completely visible elements return true:
    var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
    // Partially visible elements return true:
    //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
    return isVisible;
}

function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
}

function handleAjaxError(error) 
{
    if (error.response.status != 400) {
        this.errors = { state: ['Server Error! HTTP ' + error.response.status]};
    } else {
        var body = error.response.data;
        this.errors = body.state;
    }
    this.$nextTick(() => {
        var element = document.getElementById('errors');
        
        if (element && !isScrolledIntoView(element)) {
            var rect = element.getBoundingClientRect();
            var elemTop = rect.top;
            window.scrollBy({left: 0, top: elemTop-85, behavior: 'smooth'})
            //element.scrollIntoView({block: 'start',  behavior: 'smooth'});
        }
    });
}

export {axios, handleAjaxError, guid, sticky};